
import React from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';
import Sidebar from '../common/Sidebar';

const Dashboard = () => {
    return (
        // <div>
        //     <Header />
        //     <Sidebar />
        //     <div className="main-container">
        //   <div className="pd-ltr-20">
        //     <div className="card-box pd-20 height-100-p mb-30">
        //       <div className="row align-items-center">
        //         {/* <div className="col-md-4">
        //           <img src="vendors/images/banner-img.png" alt="" />
        //         </div>
        //         <div className="col-md-8">
        //           <h4 className="font-20 weight-500 mb-10 text-capitalize">
        //             Welcome back <div className="weight-600 font-30 text-blue">Johnny Brown!</div>
        //           </h4>
        //           <p className="font-18 max-width-600">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde hic non repellendus debitis iure, doloremque assumenda. Autem modi, corrupti, nobis ea iure fugiat, veniam non quaerat mollitia animi error corporis.</p>
        //         </div> */}
        //       </div>
        //     </div>
        //   </div>
        // </div>
        //     <Footer />
        // </div>
         <div className="card-box pd-20 height-100-p mb-30">
              <div className="row align-items-center">
                {/* <div className="col-md-4">
                  <img src="vendors/images/banner-img.png" alt="" />
                </div>
                <div className="col-md-8">
                  <h4 className="font-20 weight-500 mb-10 text-capitalize">
                    Welcome back <div className="weight-600 font-30 text-blue">Johnny Brown!</div>
                  </h4>
                  <p className="font-18 max-width-600">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde hic non repellendus debitis iure, doloremque assumenda. Autem modi, corrupti, nobis ea iure fugiat, veniam non quaerat mollitia animi error corporis.</p>
                </div> */}
              </div>
            </div>
    );
};

export default Dashboard;
